import { createSlice } from "@reduxjs/toolkit";
import { getAdminFlightsListThunk } from "../thunks/flightThunk";

const initialState = {
    flights: null,
};

const flightSlice = createSlice({
    name: "flight",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAdminFlightsListThunk.fulfilled, (state, action) => {
            state.flights = action?.payload?.data;
        })
    }
});

export default flightSlice.reducer;
